export const ProfilePageStyles = () => {
    return {
        '.userInfo__profile-name': {
            fontWeight: 'bold',
            fontSize: '1.5rem',
            textTransform: 'capitalize'
        },
        '.userInfo__help': {
            display: "flex",
            flexDirection: "column"
        },
        '.userInfo__sharing': {
            borderTop: '1px solid #dadada',
            marginTop: '20px'
        },
        '.userInfo__account': {
            borderTop: '1px solid #dadada',
            marginTop: '20px'
        }
    }
}
